// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"create-complaint-view_wrapper__1EPbw","submitButtonWrapper":"create-complaint-view_submitButtonWrapper__1ahZp"};